/**
 * 当前时间 —— `YYYY-MM-DD HH:mm`（本地时区）。
 *
 * ⚠️ 两种旧说法（**合并保留**）:
 *   · `BindCardModal` 的: 「当前激活时间 (开卡时间)」
 *   · `ConvertStudentModal` 的: 「当前时间 (「开卡时间将记录为」那句提示用) —— 跟绑卡 modal 同口径」
 *
 * ⚠️ 口径说明: `getFullYear` / `getMonth` / `getDate` / `getHours` / `getMinutes` **全是本地时区**
 *   （⛔ 不用 `toISOString()` —— 那会转成 UTC ⇒ 本地凌晨 0~8 点会写成前一天/前一天的时刻）。
 */
export function nowFormatted() {
  const d = new Date();
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/utils/NowFormatted', { nowFormatted: nowFormatted, });